import {
  RecurringRuleRecurringRuleInterval,
  RoboGoalParametersRoboInfusionFreq,
} from '@fintronners/react-api/src/graphql/types/graphql';
import { V1RecurringRuleInterval, V1RoboInfusionFreq } from '../tsoai';
import i18next from '@fintronners/react-language/src/Lang';

type IntervalGroups = {
  [key in
    | V1RoboInfusionFreq
    | V1RecurringRuleInterval
    | RoboGoalParametersRoboInfusionFreq
    | RecurringRuleRecurringRuleInterval]: string;
};

/**
 * Mapping for handling the display of the frequency intervals for
 * robo investments and scheduled transactions
 */
export const FrequencyDisplayStringMap: IntervalGroups = {
  [V1RoboInfusionFreq.Monthly]: i18next.t('common.frequencyValue.monthly'),
  [V1RoboInfusionFreq.SemiAnnually]: i18next.t('common.frequencyValue.semiAnnually'),
  [V1RoboInfusionFreq.SemiMonthly]: i18next.t('common.frequencyValue.semiMonthly'),
  [V1RoboInfusionFreq.Unspecified]: i18next.t('common.frequencyValue.unspecified'),
  [V1RoboInfusionFreq.Weekly]: i18next.t('common.frequencyValue.weekly'),
  [V1RoboInfusionFreq.BiWeekly]: i18next.t('common.frequencyValue.biWeekly'),
  [V1RoboInfusionFreq.Yearly]: i18next.t('common.frequencyValue.yearly'),
  [V1RecurringRuleInterval.Unspecified]: i18next.t('common.frequencyValue.unspecified'),
  [V1RecurringRuleInterval.Once]: i18next.t('common.frequencyValue.once'),
  [V1RecurringRuleInterval.EveryWeek]: i18next.t('common.frequencyValue.weekly'),
  [V1RecurringRuleInterval.EveryTwoWeeks]: i18next.t('common.frequencyValue.biWeekly'),
  [V1RecurringRuleInterval.EveryFourWeeks]: i18next.t('common.frequencyValue.everyFourWeeks'),
  [V1RecurringRuleInterval.EveryMonth]: i18next.t('common.frequencyValue.monthly'),
  [V1RecurringRuleInterval.TwiceEveryMonth]: i18next.t('common.frequencyValue.twiceEveryMonth'),
  [V1RecurringRuleInterval.EveryTwoMonths]: i18next.t('common.frequencyValue.everyTwoMonths'),
  [V1RecurringRuleInterval.EveryThreeMonths]: i18next.t('common.frequencyValue.everyThreeMonths'),
  [V1RecurringRuleInterval.SixMonths]: i18next.t('common.frequencyValue.sixMonths'),
  [V1RecurringRuleInterval.EveryYear]: i18next.t('common.frequencyValue.yearly'),
};

export const RecurringIntervalsLabelMap = {
  every_week: V1RecurringRuleInterval.EveryWeek,
  every_two_weeks: V1RecurringRuleInterval.EveryTwoWeeks,
  every_month: V1RecurringRuleInterval.EveryMonth,
};

export const RecurringIntervalsLabelMapKeys = {
  [V1RecurringRuleInterval.EveryWeek]: 'every_week',
  [V1RecurringRuleInterval.EveryTwoWeeks]: 'every_two_weeks',
  [V1RecurringRuleInterval.EveryMonth]: 'every_month',
  [V1RecurringRuleInterval.EveryFourWeeks]: null,
  [V1RecurringRuleInterval.EveryThreeMonths]: null,
  [V1RecurringRuleInterval.EveryTwoMonths]: null,
  [V1RecurringRuleInterval.EveryYear]: null,
  [V1RecurringRuleInterval.Once]: null,
  [V1RecurringRuleInterval.SixMonths]: null,
  [V1RecurringRuleInterval.TwiceEveryMonth]: null,
};

export const getNamedFreqDisplayString = (
  input: keyof typeof FrequencyDisplayStringMap | undefined,
) => {
  if (input === undefined) {
    return '';
  }
  return FrequencyDisplayStringMap[input] || '';
};

export const commonFrequencyInterval = [
  RoboGoalParametersRoboInfusionFreq.RoboInfusionFreqWeekly,
  RoboGoalParametersRoboInfusionFreq.RoboInfusionFreqBiWeekly,
  RoboGoalParametersRoboInfusionFreq.RoboInfusionFreqMonthly,
];
